import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="logoContainer">
          <img src="logo512.png" className="App-logo" alt="logo" />
        </div>
        <p>
          Barka da zuwa shafin <code>Gina Manhaja</code> na yanar gizo. Muna
          gyara akan wannan shafin, amma zaku iya samunmu ta:
        </p>
        <ol>
          <li>
            <a
              className="App-link"
              href="https://www.facebook.com/GinaManhaja"
              target="_blank"
              rel="noopener noreferrer"
            >
              Shafin Facebook
            </a>
          </li>
          <li>
            <a
              className="App-link"
              href="https://t.me/GinaManhaja"
              target="_blank"
              rel="noopener noreferrer"
            >
              Zauren Telegram
            </a>
          </li>
        </ol>
      </header>
    </div>
  );
}

export default App;
